import { render } from "./IssuesByPlace.vue?vue&type=template&id=49149f9a"
import script from "./IssuesByPlace.vue?vue&type=script&lang=js"
export * from "./IssuesByPlace.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QPageScroller from 'quasar/src/components/page-scroller/QPageScroller.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QList,QItem,QItemSection,QBtn,QAvatar,QBadge,QItemLabel,QIcon,QChip,QDialog,QPageScroller});qInstall(script, 'directives', {Ripple});
